import utils from '../fn/utils'
class baseStorage {
    constructor(type,preId) {
        this.preId = preId || ''
        this.type = type || '1' // 1:localStorage 默认值  2:sessionStorage
        this.status = {
            SUCCESS: 0, // 成功
            FAILURE: 1, // 失败
            OVERFLOW: 2, // 溢出
            TIMEOUT: 3 // 过期
        }
        this.storage = this.type === '1' ? window.localStorage : window.sessionStorage
    }
    getKey(key) {
        return this.preId + key
    } // 获取数据
    get(key, callback) {
        let status = this.status.SUCCESS
        let dataKey = this.getKey(key)
        let value = null
        let result = {} // 返回结果
        try {
            value = this.storage.getItem(dataKey)
            if (!utils.isDef(value)) {
                status = this.status.FAILURE
            }
        } catch (e) {
            // 获取失败返回结果
            result = {
                status: this.status.FAILURE,
                value: null
            }
            // 执行回调并返回
            callback && callback.call(this, result.status, result.value)
        }
        result = {
            status: status,
            value: value
        }
        callback && callback.call(this, result.status, result.value)
    }
    set (key, value, callback) {
        let status = this.status.SUCCESS
        let dataKey = this.getKey(key)
        try {
            this.storage.setItem(dataKey, value)
        } catch (e) {
        // 缓存失败
            status = this.status.FAILURE
        }
        callback && callback.call(this, status, value)
    }
    remove(key, callback) {
        let status = this.status.FAILURE
        let dataKey = this.getKey(key)
        let value = null
        try {
            value = this.storage.getItem(dataKey)
        } catch (e) {
            status = this.status.FAILURE
        }
        if (value) {
            try {
                this.storage.removeItem(key)
                status = this.status.SUCCESS
            } catch (e) {
                status = this.status.FAILURE
            }
        }
        callback && callback.call(this, status, status > 0 ? null : value)
    }
}
export default baseStorage
